<template>
  <pdl-button
    secondary
    small
    :qaid="`product-attribute-button-${option.value}`"
    :class="classes"
    class="product-attribute-btn"
    @click="updateSelected"
  >
    {{ option.options.displayName }}
  </pdl-button>
</template>
<script>
import {mapState, mapGetters} from 'vuex';
import {PdlButton} from '@pedal/pdl-button';
import {isInStock} from '@/components/containers/pdp/utils/retailer-helpers';

export default {
  name: 'ProductAttributeButton',
  components: {
    PdlButton,
  },
  props: {
    option: {
      type: Object,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
    selectedOption: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      optionUnavailable: false,
    };
  },
  computed: {
    ...mapGetters('backend', ['b2b']),
    ...mapState('pdp', ['isECommAvailable']),
    optionProductCode() {
      return this.option.options?.productCode;
    },
    classes() {
      return {
        selected: this.option.options.displayName === this.selectedOption?.options?.displayName,
        unavailable: this.optionUnavailable,
      };
    },
  },
  watch: {
    optionProductCode() {
      this.determineOptionAvailability();
      if (this.classes.selected === true) {
        this.updateSelected();
      }
    },
  },
  created() {
    this.determineOptionAvailability();
  },
  methods: {
    updateSelected() {
      this.$emit('change', {option: this.option});
    },
    determineOptionAvailability() {
      this.optionUnavailable = false;

      this.product?.variants?.forEach((variant) => {
        if (
          this.isECommAvailable &&
          variant.code === this.optionProductCode &&
          !isInStock(this.b2b, variant.globalStockStatus)
        ) {
          this.optionUnavailable = true;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.product-attribute-btn {
  &.button--secondary {
    border: 1px solid var(--gray-20);
    padding: 0.5rem;
    position: relative;
    white-space: nowrap;
    &:after {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
    &:focus,
    &:hover {
      background: var(--blue-10);
      border: 1px solid var(--blue-100);
      box-shadow: inset 0px 0px 2px 1px var(--blue-100);
    }
    &.unavailable {
      background: var(--gray-10);
      color: var(--gray-70);
      border: 1px solid var(--gray-70);
      &:focus,
      &:hover {
        border: 1px solid var(--blue-100);
      }

      &:after {
        background: linear-gradient(
          to top left,
          transparent 0,
          transparent 49%,
          var(--gray-70) 50%,
          transparent 51%,
          transparent
        );
      }
    }
    &.selected {
      border: 1px solid var(--blue-100);
      box-shadow: inset 0px 0px 0px 1px var(--blue-100);
      &:focus,
      &:hover {
        background: var(--blue-10);
        box-shadow: inset 0px 0px 2px 1px var(--blue-100);
      }
    }
  }
}
</style>
